// extracted by mini-css-extract-plugin
export default {"magicFlagActions":"MagicFlagSettings_magicFlagActions__wCMCi","magicFlagTable":"MagicFlagSettings_magicFlagTable__styeq"};